module.exports = __webpack_public_path__ + "img/geofisica_9-16_360.299371b2.jpg";